export default function getSatellite() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (!window._satellite?.buildInfo) return;
      clearInterval(interval);
      resolve(window._satellite);
    }, 0);
  });
}
